/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

// src/components/common/AlertDialogService.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import AlertDialog from "./AlertDialog";

// The context and a hook for it
const AlertDialogContext = createContext();

export function useAlertDialog() {
    return useContext(AlertDialogContext);
}

// The provider: wrap your app with this
export function AlertDialogProvider({ children }) {
    // State for the current alert
    const [dialog, setDialog] = useState({
        open: false, title: "", message: "", type: "info",
        okLabel: "OK", cancelLabel: "Cancel", showCancel: true,
        onOk: undefined, onCancel: undefined,
    });

    // This function will show the dialog, called anywhere in tree
    const showDialog = useCallback(
        ({ title, message, type = "info", okLabel = "OK", cancelLabel = "Cancel", showCancel = true, onOk, onCancel }) => {
            setDialog({
                open: true,
                title,
                message,
                type,
                okLabel,
                cancelLabel,
                showCancel,
                onOk: () => {
                    setDialog(d => ({ ...d, open: false }));
                    onOk?.();
                },
                onCancel: () => {
                    setDialog(d => ({ ...d, open: false }));
                    onCancel?.();
                },
            });
        },
        []
    );

    // Used by all children
    return (
        <AlertDialogContext.Provider value={{ showAlertDialog: showDialog }}>
            {children}
            <AlertDialog {...dialog} open={dialog.open} />
        </AlertDialogContext.Provider>
    );
}
